<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="姓名" property="personName">
									<el-input
										v-model="searchForm.personName"
										placeholder="请输入姓名"
										clearable
										@keyup.enter.native="get_student"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="学号" property="personNo">
									<el-input
										v-model="searchForm.personNo"
										placeholder="请输入学号"
										clearable
										@keyup.enter.native="get_student"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="状态" property="statusFlag">
									<el-select
										v-model="searchForm.statusFlag"
										placeholder="请选择状态"
										clearable
										@change="get_baobiao"
									>
									<el-option label="全部" :value="-1"></el-option>
									<el-option label="待审核" :value="0"></el-option>	
									<el-option label="已审核" :value="1"></el-option>	
									</el-select>
								</el-form-item>
								<el-form-item label="日期范围" property="dateRange">
									<span>
										<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											unlink-panels
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											:picker-options="pickerOptions"
											@change="get_baobiao"
										/>
									</span>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="get_baobiao(true)">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools">
							<el-button type="primary" @click="generateBatch">生成批次</el-button>
							<!-- <el-button type="primary" @click="exportExcel">导出</el-button> -->
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					>
						<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
						<el-table-column prop="buildingName" label="退前房间" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.buildingName}}-{{scope.row.roomNo}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="personName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="personNo" label="学号" align="center"></el-table-column>
						<el-table-column prop="dealMoney" label="退款金额（元）" align="center">
							<template slot-scope="scope">
								{{scope.row.dealMoney ? parseFloat(scope.row.dealMoney).toFixed(2) : 0}}
							</template>
						</el-table-column>
						<el-table-column prop="statusFlag" label="状态" align="center">
							<template slot-scope="scope">
								<el-tag :type="scope.row.statusFlag == 0 ? 'warning' : 'success'">{{scope.row.statusFlag == 0 ? '待审核' : scope.row.statusFlag == 1 ? '已审核' : '未知'}}</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="accountName" label="登记姓名" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="openBank" label="开户行" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="accountNo" label="卡号" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="createTime" label="订单申请时间" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="batchNo" label="退款批次" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.batchNo ? scope.row.batchNo : '-'}}</span>
							</template>
						</el-table-column>
						<!-- <el-table-column
						  prop="icon"
						  fixed="right"
						  align="center"
						  label="操作">
							<template slot-scope="scope">
								<el-button v-if="scope.row.personMoney > 0" type="text" @click="viewHandle(scope.row)">扣费详情</el-button>
							</template>
						</el-table-column> -->
					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<el-dialog
		  title="批次确认"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">
		    <el-alert
				title="此操作会将所有未处理订单进行确认，确认后可前往“退款批次表”中进行导出"
				type="warning"
				:closable="false">
			</el-alert>
			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">
				<el-form-item label="批次名称" prop="batchName">
					<el-input v-model="editForm.batchName" placeholder="请输入批次名称" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getTuiShenqing, getTuiExport, batchConfirm } from '@/apis/tuikuan'
export default {
	name: "Refund",	// 报表
	data() {
		return {
			nowDate: '',
			loading: false,

			searchForm: {},
			editForm: {},
			dateRange: [],
			dateRangeMoren: [],		// 默认日期范围
			TreeData: [
				{id: 0, name: '数据加载中' }
			],

			total: 0,
			size: 10,
			current: 1,

			clickRow: {},

			tableData: [],

			dialogVisible: false,
			editFormRules: {
				batchName: [
					{required: true, message: '请输入批次名称', trigger: 'blur'}
				]
			},

			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		let t = new Date()
		let startDate = t.getFullYear()-1 + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-01'
		let endDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2)
		this.nowDate = endDate
		this.dateRange = [startDate, endDate]
		this.dateRangeMoren = [startDate, endDate]
		this.get_baobiao()
	},
	methods: {
		resetSearchForm() {
			this.current = 1
			this.searchForm = {}
			this.get_baobiao()
		},
		exportExcel() {
			const loading = this.$loading({
				text: '加载中...',
			});
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomId && searchObj.roomId.length) {
				let room = searchObj.roomId[ searchObj.roomId.length - 1 ].toString()
				searchObj.roomId = room
			} else {
				delete searchObj.roomId
			}
			getTuiExport({...searchObj, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]}).then(res => res.data).then(res => {
				loading.close()
				// console.log(res);
				if (res.code == 200) {
					if (res.data.length) {
						let excelData = res.data.map((it, index) => ({index: index + 1, mc: `${it.buildingName}-${it.roomNo}`, time: it.dealTime, 
							czTime: it.createTime, nickname:it.nickname, dealInfo:it.dealInfo
						}))
                        this.getExcel(excelData)
					} else {
						this.$message({
							type: 'error',
							message: "没有可导数据"
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            // 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
            XLSX.utils.sheet_add_aoa(worksheet, [['序号', '房间', '用量日期', '用电量', '类型', '账户类型', '交易前配额' , '交易配额', '交易后配额', '交易前余额' , '交易金额', '交易后余额', '操作时间', '操作员', '备注']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `房间交易记录${this.nowDate}.xlsx`)
        },
		arraySpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex ===4) { // 只对第4列进行合并
				if (rowIndex === 0) {
				return {
					rowspan: this.getRowSpan(row.category),
					colspan: 1,
				};
				} else {
					const prevRow = this.dialog.tableData[rowIndex - 1];
					if (prevRow.category === row.category) {
						return {
							rowspan: 0,
							colspan: 0,
						};
					} else {
						return {
							rowspan: this.getRowSpan(row.category, rowIndex),
							colspan: 1,
						};
					}
				}
			}
		},
		getRowSpan(category, startIndex = 0) {
			let count = 0;
			for (let i = startIndex; i < this.dialog.tableData.length; i++) {
				if (this.dialog.tableData[i].category === category) {
					count++;
				} else {
					break;
				}
			}
			return count;
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},

		handleSizeChange(val) {
			this.size = val
			this.get_baobiao()
		},
		handleCurrentChange(val) {
			this.current = val
			this.get_baobiao()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		generateBatch() {
			this.editForm = {}
			this.dialogVisible = true
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					batchConfirm({batchName: this.editForm.batchName}).then(res => res.data).then(res => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.get_baobiao()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
						this.resetForm('editForm')
					})
				}
			})
		},
		get_baobiao(resetPage = false) {
			if (resetPage) {
				this.current = 1
			}
			this.loading = true
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomId && searchObj.roomId.length) {
				let room = searchObj.roomId[ searchObj.roomId.length - 1 ].toString()
				searchObj.roomId = room
			} else {
				delete searchObj.roomId
			}
			getTuiShenqing({current: this.current, size: this.size, statusFlag: -1, ...searchObj, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]
			}).then(res => res.data).then(res => {
				// console.log(res);
				this.tableData = res.data.records
				this.total = res.data.total
				this.loading = false
			})
		},

	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>